<template>
  <table class="table table-hover">
    <thead>
      <tr class="heading">
        <td></td>
        <td></td>
        <td>{{ i18nJS.pais_targets_verification.data }}</td>
        <td class="center">{{ i18nJS.pais_targets_verification.reached }}</td>
        <td>{{ i18nJS.pais_targets_verification.motivation }}</td>
        <td>{{ i18nJS.pais_targets_verification.notes }}</td>
        <td>{{ i18nJS.pais_targets_verification.date_verify }}</td>
      </tr>
    </thead>
    <tbody>
      <tr v-for="verification in verifications" :key="verification.id">
        <td>
          <a href="javascript:void(0)" @click="() => (verifyToBeModify[verification.id] ? save(verification) : edit(verification.id))">
            <i v-show="verifyToBeModify[verification.id]" class="fa-light fa-floppy-disk green" />
            <i v-show="!verifyToBeModify[verification.id]" class="fa-light fa-pencil green" />
          </a>
        </td>
        <td>
          <a
            href="javascript:void(0)"
            @click="() => (verifyToBeModify[verification.id] ? reset(verification.id) : destroy(verification.id))"
          >
            <i v-show="!verifyToBeModify[verification.id]" class="fa-light fa-trash red" />
            <i v-show="verifyToBeModify[verification.id]" class="fa-light fa-arrow-rotate-left orange" />
          </a>
        </td>
        <td>
          <span v-show="verifyToBeModify[verification.id]">
            <datepicker v-model="verification.data" :value="verification.data" />
          </span>
          <span v-show="!verifyToBeModify[verification.id]">
            {{ verification.data }}
          </span>
        </td>
        <td class="center">
          <span v-show="verifyToBeModify[verification.id]">
            <v-select2
              :value="verification.reached"
              v-model="verification.reached"
              :options-list="[
                ['Non raggiunto', 0],
                ['Raggiunto', 2],
                ['Parzialmente raggiunto', 1],
              ]"
              data-allow-clear="false"
            />
          </span>
          <span v-show="!verifyToBeModify[verification.id]">
            <i v-if="verification.reached == 0" class="fa-light fa-face-frown red" />
            <i v-else-if="verification.reached == 1" class="fa-light fa-face-meh yellow" />
            <i v-else-if="verification.reached == 2" class="fa-light fa-face-smile green" />
          </span>
        </td>
        <td>
          <span v-show="verifyToBeModify[verification.id]">
            <template v-if="motivazioniTabellate">
              <v-select2
                :value="verification.motivations_list"
                v-model="verification.motivations_list"
                :options-list="motivations"
                :multiple="true"
              />
              <br />
            </template>
            <textarea v-model="verification.motivation"></textarea>
          </span>
          <span v-show="!verifyToBeModify[verification.id]">
            <template v-if="motivazioniTabellate && verification.motivations_list">
              {{ getMotivation(verification.motivations_list) }}
              <br />
            </template>
            {{ verification.motivation }}
          </span>
        </td>
        <td>
          <span v-show="verifyToBeModify[verification.id]">
            <textarea v-model="verification.notes"></textarea>
          </span>
          <span v-show="!verifyToBeModify[verification.id]">
            {{ verification.notes }}
          </span>
        </td>
        <td>
          <span v-show="verifyToBeModify[verification.id]">
            <datepicker v-model="verification.date_verify" :value="verification.date_verify" />
          </span>
          <span v-show="!verifyToBeModify[verification.id]">
            {{ verification.date_verify }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import vSelect2 from '../vSelect2';
import datepicker from '../datepicker';

export default {
  name: 'paisTargetsVerifications',
  components: {
    vSelect2,
    datepicker,
  },
  props: {
    items: { type: Array, default: () => [] },
    motivations: { type: Array, default: () => [] },
    motivazioniTabellate: { type: Boolean, default: false },
    url: { type: String },
  },
  data() {
    return {
      verifyToBeModify: {},
      verifications: [],
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  mounted() {
    this.verifications = this.items;
  },
  methods: {
    getMotivation(motivations_list) {
      if (!motivations_list) return '';

      let string = [];
      motivations_list.forEach((motivation) => {
        let val = this.motivations.find((m) => m[1] === motivation);
        if (val) string.push(val[0]);
      });
      return string.join(', ');
    },
    edit(verification_id) {
      this.$set(this.verifyToBeModify, verification_id, true);
    },
    save(verification) {
      const params = { pais_targets_verification: verification };
      Loader.show();
      apiConnector()
        .put(`${this.url}/${verification.id}.json`, params)
        .then(() => {
          Loader.hide();
          this.$set(this.verifyToBeModify, verification.id, false);
        });
    },
    destroy(verification_id) {
      if (!confirm(this.i18nJS.command.confirm)) return;

      Loader.show();
      apiConnector()
        .delete(`${this.url}/${verification_id}.json`)
        .then(() => {
          this.verifications = this.verifications.filter((v) => v.id !== verification_id);
          Loader.hide();
        });
    },
    reset(verification_id) {
      this.$set(this.verifyToBeModify, verification_id, false);
    },
  },
};
</script>
